export default "__VITE_ASSET__$d2g5yNI__"